var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M322.27,287.92c-2.91,25.56-17.77,48.16-40.78,62-62.4,37.55-169.95,102.38-189.16,114.65a38.53,38.53,0,0,1-20.6,6.35c-23.63,0-39.57-23.37-40.62-59.55-1-32.88-6.83-55.84-13.62-82.42-5.11-20-10.38-40.6-14.59-68.63C-.93,234.82-9.29,147.17,44,90.29c30.61-32.66,76.43-49.22,136.21-49.22,2.65,0,5.35,0,8.07.1,39,.93,69,13.13,91.78,37.27C331.33,132.73,328.51,233,322.27,287.92ZM505.56,118.17C477.15,82.51,352.05,81.52,350.8,81.52c-9.47,0-12.11.4-14.91,2.27a17.19,17.19,0,0,0-5.79,7,10.51,10.51,0,0,0-.15,8.92c25.11,55.68,23.6,128.13,20.47,166.35a81,81,0,0,1-2.18,13,10.48,10.48,0,0,0,8.94,12.94,25.27,25.27,0,0,0,2.94.17h0c26.88,0,72.94-44.2,86.42-57.75,27.36-27.5,58.73-66.21,64.72-92.35C513.22,133.6,511.25,125.31,505.56,118.17Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiver);
export default __webpack_public_path__ + "static/media/liver.824645eca24755a505312d2f654c2a6c.svg";
export { ForwardRef as ReactComponent };